import React from 'react'

interface AddressData {
   addressLine1: string
   street: string
   city: string
   state: string
}

interface VirtualData {
   platform: string
   url: string
   password: string
   meetingId: string
}

interface AppointmentPreferenceViewProps {
   selectedPreference: 'PHONE-CALL' | 'IN-PERSON' | 'VIRTUAL'
   addressData: AddressData
   virtualData: VirtualData
   onEdit: () => void
}

const AppointmentPreferenceView: React.FC<AppointmentPreferenceViewProps> = ({
   selectedPreference,
   addressData,
   virtualData,
   onEdit,
}) => {
   const formatPreferenceLabel = (preference: string) => {
      switch (preference) {
         case 'PHONE-CALL':
            return 'Phone call'
         case 'IN-PERSON':
            return 'In-person'
         case 'VIRTUAL':
            return 'Virtual'
         default:
            return preference
      }
   }

   const truncateUrl = (url: string, maxLength: number = 30) => {
      if (url.length <= maxLength) return url
      return `${url.substring(0, maxLength)}..`
   }

   return (
      <div className=" bg-primary/10 text-white p-6  min-w-[500px]">
         <div className="flex items-center justify-between">
            <div className="flex items-center">
               <span className="px-4 py-2 text-sm font-medium text-white ">
                  {formatPreferenceLabel(selectedPreference)}
               </span>

               {selectedPreference === 'VIRTUAL' && (
                  <>
                     <span className="px-4 py-2 text-sm font-medium text-white border-l border-black/30">
                        {virtualData.platform === 'GOOGLE-MEET'
                           ? 'Google Meet'
                           : virtualData.platform === 'ZOOM'
                           ? 'Zoom'
                           : ''}
                     </span>
                     <span className="text-sm text-gray-300">
                        {truncateUrl(virtualData.url)}
                     </span>
                  </>
               )}

               {selectedPreference === 'IN-PERSON' && (
                  <span className="px-4 py-2 text-sm text-gray-300 border-l border-black/30">
                     {addressData.addressLine1}, {addressData.city},{' '}
                     {addressData.state}
                  </span>
               )}
            </div>

            <button
               onClick={onEdit}
               className="w-20 h-8 px-4 text-sm font-medium text-gray-300 transition-colors rounded bg-white/5 hover:text-white hover:bg-slate-600"
            >
               Edit
            </button>
         </div>
      </div>
   )
}

export default AppointmentPreferenceView
